module.exports = __webpack_public_path__ + "static/media/surgan.8bcaaa18.jpg";